import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const NextSliderArrowIconDef = {
  'next-slider-arrow': makeIconDef('next-slider-arrow', {
    regular: () => <svg fill="none"><path d="M7 1L17.2929 11.2929C17.6834 11.6834 17.6834 12.3166 17.2929 12.7071L7 23" stroke="currentColor" strokeWidth="2" /></svg>,
  })
}